import { Typography } from "@mui/material";
import React from "react";

const NoAutorizado: React.FC<{}> = () => {
  return <Typography>No Autorizado</Typography>;
};

export default NoAutorizado;
